import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesVentasTelas() {
  const { user } = useContext(AuthContext);

  const secciones = [
    { section: "", items: [
      { label: "Pedidos", icon: "fas fa-shopping-basket", color: "#2563eb", href: "/ListadoPedidosTelas", enabled: !!(user.menu_ventas && user.menu_pedidos) },
      { label: "Apartados", icon: "fas fa-people-carry", color: "#2563eb", href: "/ListadoApartadosTelas", enabled: !!(user.menu_ventas && user.menu_surtidos) },
      { label: "Surtidos", icon: "fas fa-truck-moving", color: "#2563eb", href: "/ListadoSurtidosTelas", enabled: !!(user.menu_ventas && user.menu_surtidos) },
      { label: "Devoluciones", icon: "fas fa-undo-alt", color: "#2563eb", href: "/ListadoDevolucionesTelas", enabled: !!(user.menu_ventas && user.menu_devoluciones) },
    ]},
  ];

  return (
    <MenuBotones
      titulo="Ventas de Telas"
      descripcion="Pedidos, apartados y surtidos de tela"
      icono="fas fa-scroll"
      color="#2563eb"
      secciones={secciones}
    />
  );
}

export default BotonesVentasTelas;
